export default __webpack_public_path__ + "static/media/ic_workspace_blue_48px.33f6e69a.svg";